import classNames from "classnames";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import type { TEventLogObject } from "../../../../../../services/api/instances/researchApi/types";
import { AppAccordion } from "../../../../../../shared/components/AppAcordion";
import { AppLinearLoading } from "../../../../../../shared/components/AppLoading/AppLinearLoading";
import { generateId } from "../../../../../../shared/utils/generateId";
import type { TObjectWithId } from "../../types";
import { EventCard } from "../EventCard";
import { InfoSourcesCount } from "./InfoSourcesCount";
import styles from "./styles.module.css";

interface Props {
  event: TEventLogObject;
  isResearching: boolean;
}

export const EventProgress = ({ event, isResearching }: Props) => {
  const [sources, setSources] = useState<TObjectWithId[]>([]);
  const { t } = useTranslation();

  const progressValue = isResearching ? event?.progress_meter : 100;

  useEffect(() => {
    if (!event || !event?.source_stats) return;
    const { sources_read_sample } = event.source_stats;
    if (!sources_read_sample.length) return;
    const newSourcesList: TObjectWithId[] = sources_read_sample.map((item) => ({
      id: generateId(),
      value: item,
    }));
    setSources(newSourcesList);
  }, [event]);

  return (
    <EventCard
      eventType={"progress"}
      extraContent={
        <span
          className={styles["progress-value"]}
        >{`${Math.round(progressValue ?? 0)}%`}</span>
      }
      eventBody={
        <>
          <AppLinearLoading
            variant={"determinate"}
            value={progressValue}
            className={classNames(styles.loader)}
          />
          <div className={styles["info-sources-counters"]}>
            <InfoSourcesCount
              title={t("research.sources_find")}
              sourcesCount={event?.source_stats?.num_sources_considered ?? 0}
            />
            <InfoSourcesCount
              title={t("research.sources_read")}
              sourcesCount={event?.source_stats?.num_sources_read ?? 0}
            />
          </div>
          <AppAccordion
            title={`${t("research.event_sources")}(${event?.source_stats?.num_sources_read ?? 0})`}
          >
            <div className={styles["sources-container"]}>
              {sources.map((source, index) => (
                <a
                  key={source.id}
                  href={source.value}
                  target={"_blank"}
                  className={styles["source-link"]}
                  rel="noreferrer"
                >
                  {`${index + 1}. ${source.value}`}
                </a>
              ))}
            </div>
          </AppAccordion>
        </>
      }
    />
  );
};
